import { useState } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';

import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { editItem, getItem, deleteItemWithBody } from '../../fetch';
import { useEffectAsync } from '../../reactHelper';
import { useTranslation } from '../../common/LocalizationProvider';
import { PermissionDialog } from '../permission';
import { selectDevicesArray } from '../../createSelectorUtils';

UserLinkedDevice.propTypes = {
  userId: PropTypes.number.isRequired
};
export default function UserLinkedDevice({ userId }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const allDevice = useSelector(selectDevicesArray);
  const [linkedDevice, setLinkedDevice] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffectAsync(async () => {
    if (isOpen) {
      const response = await getItem(`devices?userId=${userId}`);
      if (response.ok) {
        setLinkedDevice(await response.json());
      }
    }
  }, [isOpen]);

  const handleChange = async (event) => {
    const newDevice = allDevice.find((item) => item.id === parseInt(event.target.value, 10));
    if (newDevice) {
      const create = !linkedDevice.map((item) => item.id).includes(newDevice.id);
      const response = create
        ? await editItem('permissions', undefined, {
            userId,
            deviceId: newDevice.id
          })
        : await deleteItemWithBody('permissions', {
            userId,
            deviceId: newDevice.id
          });
      if (response.ok) {
        setLinkedDevice(
          create
            ? [...linkedDevice, newDevice]
            : linkedDevice.filter((item) => item.id !== newDevice.id)
        );
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }
    }
  };

  return (
    <>
      <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setIsOpen(true)}>
        <ListItemIcon>
          <Icon icon="bytesize:link" width={24} height={24} />
        </ListItemIcon>
        <ListItemText
          primary={t('UL_Menu_Linked_Devices')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <PermissionDialog
        title="UL_Menu_Linked_Devices"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        handleChange={handleChange}
        allObject={allDevice}
        linkedObject={linkedDevice}
      />
    </>
  );
}
